/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import '../styles/Wrapper.scss';
import { ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Sidebar from '../components/sidebar/Sidebar';
import _ from 'lodash';

import 'react-toastify/dist/ReactToastify.css';
// eslint-disable-next-line import/named
import { RouteComponentProps } from 'react-router-dom';
import { adminPaths } from '../helpers/utils';

interface AppState {
  sidebarCompact: boolean;
}

interface AppProps extends RouteComponentProps {
  profile?: {
    partnerId?: string;
  };
}

class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      sidebarCompact: props.profile?.partnerId === 'Admin',
    };
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  componentDidUpdate(prevProps: AppProps) {
    const previousPartnerId = prevProps.profile?.partnerId;
    const currentPartnerId = this.props.profile?.partnerId;

    if (previousPartnerId !== currentPartnerId && currentPartnerId === 'Admin') {
      this.setState({ sidebarCompact: true });
    }
  }

  toggleSidebar() {
    this.setState({ sidebarCompact: !this.state.sidebarCompact });
  }

  render() {
    const {
      match: { path },
    } = this.props;
    const isAdmin = this.props.profile?.partnerId === 'Admin';
    const { sidebarCompact } = this.state;
    const isCompact = sidebarCompact;
    const activeClass = isCompact ? 'compact' : '';
    const appContainerClass = `app-container ${isAdmin ? 'admin-layout' : ''}`.trim();
    const appMainClass = `app-main ${isAdmin ? 'admin-main' : ''}`.trim();
    return (
      <div className={appContainerClass}>
        <ToastContainer />
        <div className={`app-sidebar ${activeClass}`}>
          <Sidebar isCompact={isCompact} onToggleSidebar={this.toggleSidebar} />
        </div>
        <div className={appMainClass}>{this.props.children}</div>
      </div>
    );
  }
}

const mapStateToProps = ({ firebase }: any) => ({
  profile: firebase?.profile,
});

export default connect(mapStateToProps)(App);
